"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
const vue_property_decorator_1 = require("vue-property-decorator");
const ListDeliverables_vue_1 = __importDefault(require("../components/ListDeliverables.vue"));
const ListFarms_vue_1 = __importDefault(require("../components/ListFarms.vue"));
const PreviewPanel_vue_1 = __importDefault(require("../components/PreviewPanel.vue"));
const Toggle_vue_1 = __importDefault(require("../components/Toggle.vue"));
const Dashboard_1 = __importDefault(require("../class/models/Dashboard"));
const Project_1 = __importDefault(require("../class/models/Project"));
const Sample_1 = __importDefault(require("../class/models/Sample"));
const ViewZeroDeliverables_vue_1 = __importDefault(require("../components/ViewZeroDeliverables.vue"));
const TabPillsSet_vue_1 = __importDefault(require("@becrop/components/Farms/TabPillsSet.vue"));
const TabPillsSetItem_vue_1 = __importDefault(require("@becrop/components/Farms/TabPillsSetItem.vue"));
const FarmSetupCTA_vue_1 = __importDefault(require("../components/FarmSetupCTA.vue"));
let DashboardMain = class DashboardMain extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.projectSelected = new Project_1.default();
        this.sampleSelected = new Sample_1.default();
        this.farmSelected = null;
        this.scope = this.farmDataSet.length > 0 ? 'farms' : 'projects';
        this.loadingFarms = false;
    }
    startSelect() {
        this.projectSelected = this.lastProjects[0];
        this.sampleSelected = this.lastSamples[0];
    }
    get isViewZero() {
        const projectsCount = this.lastProjects.length;
        const samplesCount = this.lastSamples.length;
        const farmsCount = this.farmDataSet.length;
        if (projectsCount > 0 || samplesCount > 0 || farmsCount > 0)
            return false;
        return true;
    }
    async setProjectSelected(project) {
        this.loadingFarms = true;
        if (project.type !== 'trials') {
            await project.fetchGeodata();
        }
        this.projectSelected = project;
        this.loadingFarms = false;
    }
    setSampleSelected(sample) {
        this.sampleSelected = sample;
    }
    async setFarmSelected(farm) {
        var _a;
        this.farmSelected = farm;
        if (((_a = farm === null || farm === void 0 ? void 0 : farm.geodata) === null || _a === void 0 ? void 0 : _a.length) == 0) {
            await farm.fetchGeodata();
        }
    }
    emitFilter(filter) {
        this.$emit('filter', filter);
    }
    emitSampleFilter(filter) {
        this.$emit('samplesFilter', filter);
    }
    setActiveScope(k) {
        this.scope = k;
    }
    changeToggle(on) {
        (on) ? this.scope = 'farms' : this.scope = 'projects';
    }
    async setInitialFarm() {
        if (this.farmDataSet.length > 0) {
            await this.setFarmSelected(this.farmDataSet[0]);
        }
    }
    async setInitialProject() {
        if (this.lastProjects.length > 0) {
            await this.setProjectSelected(this.lastProjects[0]);
        }
    }
    async mounted() {
        await this.setInitialFarm();
        await this.setInitialProject();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new Dashboard_1.default() })
], DashboardMain.prototype, "dataset", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], DashboardMain.prototype, "farmDataSet", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], DashboardMain.prototype, "lastProjects", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], DashboardMain.prototype, "lastSamples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], DashboardMain.prototype, "projectsTypes", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], DashboardMain.prototype, "samplesCrops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], DashboardMain.prototype, "vuedata", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('lastProjects', { immediate: true }),
    (0, vue_property_decorator_1.Watch)('lastSamples', { immediate: true })
], DashboardMain.prototype, "startSelect", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('farmDataSet')
], DashboardMain.prototype, "setInitialFarm", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('lastProjects')
], DashboardMain.prototype, "setInitialProject", null);
DashboardMain = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            ListDeliverables: ListDeliverables_vue_1.default,
            ListFarms: ListFarms_vue_1.default,
            PreviewPanel: PreviewPanel_vue_1.default,
            ViewZeroDeliverables: ViewZeroDeliverables_vue_1.default,
            TabPillsSet: TabPillsSet_vue_1.default,
            TabPillsSetItem: TabPillsSetItem_vue_1.default,
            Toggle: Toggle_vue_1.default,
            FarmSetupCTA: FarmSetupCTA_vue_1.default
        },
    })
], DashboardMain);
exports.default = DashboardMain;
